import React, { useContext } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { RegistrationStatus } from '@/modules/common/enums';
import CeeScheduledExam from './ExamScheduled/ExamScheduled';
import CeeExamDate from './ExamDate/ExamDate';
import Waiting from './Waiting/Waiting';
import { Typography } from '@pw-tech/omni-ui';
import Pass from './Pass/Pass';
import Fail from './Fail/Fail';
const CeeFlow = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const renderComponentBasedOnStatus = () => {
    switch (registrationDetails?.cee_status) {
      case RegistrationStatus.registered:
      case RegistrationStatus.cee_missed:
        return <CeeExamDate />;
      case RegistrationStatus.cee_scheduled:
        return <CeeScheduledExam />;
      case RegistrationStatus.cee_started:
      case RegistrationStatus.cee_completed:
        return <Waiting />;
      case RegistrationStatus.cee_passed_excellence:
      case RegistrationStatus.cee_passed_lite:
        return <Pass />;
      case RegistrationStatus.cee_failed:
        return <Fail />;
      default:
        return <Typography variant="heading3">Invalid Cee Status</Typography>;
    }
  };
  return <>{renderComponentBasedOnStatus()}</>;
};
export default CeeFlow;